import React, { useState } from "react";
import styles from "./PlayerLayout.module.scss";
import { Menu, X } from "lucide-react";

interface PlayerLayoutProps {
    Header: React.ReactNode;
    Main: React.ReactNode;
    Sidebar: React.ReactNode;
}

export const PlayerLayout: React.FC<PlayerLayoutProps> = ({
    Header,
    Main,
    Sidebar,
}) => {
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    return (
        <div className={styles.layout}>
            <header className={styles.header}>
                <div className={styles.headerContent}>
                    <button
                        className={styles.menuButton}
                        onClick={() => setIsMobileSidebarOpen(true)}
                    >
                        <Menu size={24} />
                    </button>
                    {Header}
                </div>
            </header>

            <div className={styles.body}>
                <main className={styles.main}>{Main}</main>

                <aside className={styles.sidebar}>{Sidebar}</aside>

                {isMobileSidebarOpen && (
                    <div
                        className={styles.mobileSidebarOverlay}
                        onClick={() => setIsMobileSidebarOpen(false)}
                    >
                        <div
                            className={styles.mobileSidebar}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className={styles.closeButton}
                                onClick={() => setIsMobileSidebarOpen(false)}
                            >
                                <X size={24} />
                            </button>
                            {Sidebar}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
